export const styles = {
  wrapper: {
    margin: 'auto',
  },
  avatar: {
    backgroundRepeat: 'no-repeat',
    margin: 'auto',
    position: 'absolute',
    top: -1,
    left: -1,
  },
  avatarWrapper: {
    margin: 'auto',
    position: 'relative',
  },
  reactAvatar: {
    position: 'absolute',
    display: 'block',
    overflow: 'hidden',
  },
};

export const getAvatarWrapperStyles = size => {
  return Object.assign({}, styles.avatarWrapper, { height: size, width: size });
};

export const getAvatarImageStyles = (avatarUrl, size) => {
  const extraSizeForOverlap = size + 2;
  const avatar = {
    backgroundImage: avatarUrl ? `url("${avatarUrl}")` : null,
    height: extraSizeForOverlap,
    width: extraSizeForOverlap,
    backgroundSize: extraSizeForOverlap,
    borderRadius: Math.ceil(extraSizeForOverlap / 2),
  };

  return Object.assign({}, styles.avatar, avatar);
};
